import ForYou from '$icons/ForYouIcon.svelte';
import Explore from '$icons/ExploreIcon.svelte';
import Galleries from '$icons/GalleriesIcon.svelte';
import Challenges from '$icons/ChallengesIcon.svelte';

export const hometabs = [
  { title: 'For you', icon: ForYou, value: 'for-you' },
  { title: 'Explore', icon: Explore, value: 'explore' },
  { title: 'Galleries', icon: Galleries, value: 'galleries' },
  { title: 'Challenges', icon: Challenges, value: 'challenges' }
] as const;
